<template>
  <div>
    <TenderTabsContainer :isTender="isTender">
      <General slot="general" />
      <ScopeOfWork slot="scopeOfWork" />
      <ItemsServices slot="itemServices" />
      <Attachments
        slot="fileUpload"
        :files="attachment.files"
        :description="attachment.description"
        :showTenderHints="true"
        :zipName="zipNames.attachments"
      />
      <TermsConditions
        slot="termsConditions"
        :tenderId="tenderId"
        :tenderStatus="tenderStatus"
        :isTender="isTender"
        :zipName="zipNames.terms"
      />
      <slot />
    </TenderTabsContainer>
  </div>
</template>

<script>
import lodash from 'lodash'
import HTTP from '@/utils/http'
import General from '@/modules/tenders/view/General'
import ScopeOfWork from '@/modules/tenders/view/ScopeOfWork'
import ItemsServices from '@/modules/tenders/view/ItemsServices'
import TermsConditions from '@/modules/tenders/TermsConditions'
import Attachments from '@/modules/tenders/view/Attachments'
import TenderTabsContainer from '@/modules/tenders/TenderTabsContainer'
import { mapGetters } from 'vuex'

export default {
  components: {
    General,
    ScopeOfWork,
    ItemsServices,
    TermsConditions,
    Attachments,
    TenderTabsContainer,
  },
  data () {
    return {
      tenderId: this.$router.currentRoute.params.id || '',
      active: 'mobile-tabls-general',
      text: 'This is a tab component',

      readonly: false,
      allowEdit: true,
      showConfirm: false,
      homePageUrl: '/',
      showMessage: false,
      alert: false,
      isInfo: true,
      isError: false,
      message: '',
      attachmentFiles: [],
    }
  },
  methods: {
    async initAttachments () {
      const attchmentResp = await HTTP.get(`/docs/?src=${this.tenderId}`)
      this.attachmentFiles = lodash.get(attchmentResp, ['data', 'data'], [])
    },
  },
  async mounted () {
    this.tenderId = this.$router.currentRoute.params.id
    await this.initAttachments()
  },
  computed: {
    ...mapGetters('tenders', {
      currentTender: 'currentTender',
      zipNames: 'zipNames',
    }),
    // TODO @Gino remove after sub tabs all migrate to vuex
    attachment () {
      return {
        description: this.currentTender && this.currentTender.general ? this.currentTender.general.attachmentDescription : '',
        files: this.attachmentFiles || [],
      }
    },
    isTender () {
      return this.currentTender.general.tenderType === 'TENDER'
    },
    tenderStatus () {
      return this.currentTender.general.status
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/tender/view";

.tender-preview-hint {
  margin-bottom: 1vh;
  float: left;
}

.callout {
  margin: 0;
  padding: 0.8rem 1.3rem;
}

.alert .tender-font {
  color: #f44336;
}
</style>
